import { createContext, useContext } from 'react';
export var EducationalDialogTriggerContext = createContext(null);
export var useEducationalDialogTrigger = function (fallbackTrigger) {
    if (fallbackTrigger === void 0) { fallbackTrigger = function () { }; }
    var context = useContext(EducationalDialogTriggerContext);
    if (context) {
        return context;
    }
    return fallbackTrigger;
};
